import axios from "axios";


const baseURL =
    process.env.NODE_ENV === "production"
        ? process.env.REACT_APP_MERCADIM_BASE_URL_PRO
        : process.env.REACT_APP_MERCADIM_BASE_URL_DEV;

// const baseURL = "http://mercadim.ifce.edu.br/";

export const api = axios.create({
    baseURL: baseURL + "api",
    headers: {
        Accept: "application/json",
    },
});































//Cadastrando uma usuário
export async function cadastroEvento(data) {
    const result = await api.post("/cadastrarEvento", data);

    return result.data;
}

export async function getAllPessoas() {
    const result = await api.get("/pessoasDivulgacao");
    return result.data.divulgacao;
}